/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { paymentLinksGetQRCode } from "../../funcs/paymentLinksGetQRCode.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetPaymentLinkQRCodeRequest$inboundSchema,
};

export const tool$paymentLinksGetQRCode: ToolDefinition<typeof args> = {
  name: "payment-links-get-QR-code",
  description: `Retrieve the payment link encoded in a QR code. 

Use the \`Accept\` header to specify the format of the response. Supported formats are \`application/json\` and \`image/png\`.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/transfers.write\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await paymentLinksGetQRCode(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
